export const INVOICE_CONTEXT_ONLY_TAG_HINT =
  'Only the Invoice tag verifies the document source; other tags attach it for context.';

export const INVOICE_DOCUMENT_TYPES_HINT =
  'Tag the invoice as Invoice. One document can carry several types.';
